import { useState, useEffect, useRef } from 'react';

/* PDF VIEWER */
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';


/* CSS */
import '../styles/stepper.css'
/* CSS PDF VIEWER */
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


/* COMPONENTS */
import BackdropModal from '../components/modals/backdrop_modal';
import Tooltip from '@mui/material/Tooltip';
import Swal from 'sweetalert2';





const PDFImageViewer2 = ({ onImageChange, title="Capture an Image", subtitle="", btnCameraTitle="Open Camera",keyName="captured-image",preLoadedImage }) => {


    const [cameras, setCameras] = useState([]); // Store available cameras
    const [selectedCamera, setSelectedCamera] = useState(null); // Store selected camera


    // GET ALL CAMERAS
    useEffect(() => {
        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                const videoDevices = devices.filter(device => device.kind === 'videoinput');
                setCameras(videoDevices);
            })
            .catch(error => {
                console.error('Error accessing media devices:', error);
            });
    }, []);


useEffect(() => {
    if (preLoadedImage && preLoadedImage.length > 0) {
        // If preLoadedImage is an array of images, set them to capturedImages
        setCapturedImages(preLoadedImage);

        // if(preLoadedImage.scannedImages[0].type==="application/pdf"){
        //     setPdfFile(preLoadedImage.scannedImages[0].data);
        // }
 
    }
    else if(preLoadedImage){

        if(preLoadedImage.type==="application/pdf"){
            let reader = new FileReader();
            reader.readAsDataURL(preLoadedImage);
    
            reader.onloadend = (e) => {
                setPdfError('');
                setPdfFile(e.target.result); // Set the file content (data URL)
                setIsPDF(true)
            };
        }
    }
}, [preLoadedImage]);


  /* FOR IMAGE */
  const [capturedImages, setCapturedImages] = useState([]); // Track multiple images
  const [imageName, setImageName] = useState('');
  const [preview, setPreview] = useState(null);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [showOpenCameraButton, setShowOpenCameraButton] = useState(true);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [isAnimating, setIsAnimating] = useState(false);


  /* FOR PDF */
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: () => null, // Disable the toolbar completely
  });
  // pdf file onChange state
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfError, setPdfError] = useState('');
  const [open, setOpen] = useState(false);

  const handleClose = () => {
      setOpen(false);
  };

  const playClickSound = () => {
    const clickSound = new Audio('/iusevolutione/assets/audio/camera_shutter.mp3'); // Provide path to your click sound
    clickSound.play();
  };

  // handle file onChange event
  const allowedFiles = [
      'application/pdf',            // PDF
      'image/jpeg',                 // JPG
      'image/png',                  // PNG
      'image/tiff',                 // TIFF
  ];

  const [isPDF, setIsPDF] = useState(false);

  const handleFile = (e) => {
      const selectedFile = e.target.files[0];
 
      if (selectedFile) {
          // Check if the file type is allowed
          if (allowedFiles.includes(selectedFile.type)) {
              let reader = new FileReader();
              reader.readAsDataURL(selectedFile);

              reader.onloadend = (e) => {
                  setPdfError('');
                  setPdfFile(e.target.result); // Set the file content (data URL)
              };

              if (selectedFile.type === 'application/pdf') {
                  setPreview(null);
                  setPdfError('');
                  setOpen(true);
                  setIsPDF(true);
                  setIsCameraOpen(false);
                  setShowOpenCameraButton(true);
                  setCapturedImages([]);
 


                  onImageChange(selectedFile, keyName,"add","pdf");
              } 
              else if (selectedFile.type.startsWith('image/')) {
                // Get the selected file
                const file = e.target.files[0];




                // IF RECAPTURING / REUPLOADING AN IMAGE
                if (recapturingPageIndex !== null) {
                    const pageIndex = recapturingPageIndex !== null ? recapturingPageIndex + 1 : capturedImages.length + 1;

                    // Generate the new image name dynamically
                    const finalImageName = `page${pageIndex}.png`;
                    setImageName(finalImageName);                
                    const newFile = new File([file], finalImageName, { type: file.type });

                  
                    // Use FileReader to preview the image
                    const fileReader = new FileReader();
                    fileReader.onload = () => {
                        setPreview(fileReader.result);
                    };
                    fileReader.readAsDataURL(newFile);

                
                    setCapturedImages(prevImages => {
                        const updatedImages = [...prevImages];
                        updatedImages[recapturingPageIndex] = newFile;
                        onImageChange(updatedImages, keyName,"recapture");
                        return updatedImages;
                    });
                    setRecapturingPageIndex(null);
                } 
                
                // IF ADDING ONLY 
                else {
                    const totalFiles = capturedImages.length + 1;
                    const finalImageName = `page${totalFiles}.png`;
                    setImageName(finalImageName);
                
                    const newFile = new File([file], finalImageName, { type: file.type });
                
                    // Use FileReader to preview the image
                    const fileReader = new FileReader();
                    fileReader.onload = () => {
                        setPreview(fileReader.result);
                    };
                    fileReader.readAsDataURL(newFile);
                    onImageChange(newFile, keyName);
                }
               

                setIsCameraOpen(false);
                setShowOpenCameraButton(false);
            
                setIsPDF(false);
            }
            
          } else {
              setPdfError('Not a valid file: Please select only PDF or image files (JPG, PNG, TIFF).');
              setPdfFile('');
          }
      } else {
          console.log('Please select a file');
      }
  };

  const openCamera = () => {
      setIsCameraOpen(true);
      setPreview(null);
      setImageName("");
      setShowOpenCameraButton(false);

     

      
    // navigator.mediaDevices.enumerateDevices()
    //     .then(devices => {
    //         const videoDevices = devices.filter(device => device.kind === 'videoinput');
    //         setCameras(videoDevices);
    //         if (videoDevices.length > 0) {
    //             setSelectedCamera(videoDevices[0].deviceId); // Default to the first camera
    //         }
    //     })
    //     .catch(error => {
    //         console.error('Error accessing media devices:', error);
    //     });

    if(cameras.length > 0){
        if (!selectedCamera) {
            setSelectedCamera(cameras[0].deviceId);
        }
   

  
         const constraints = {
            video: {
                deviceId:  selectedCamera ? { exact: selectedCamera } : cameras[0].deviceId,
                width: 275,
                height: 275,
            },
        };

        navigator.mediaDevices.getUserMedia(constraints)
        .then(stream => {
            try {
                // Ensure the videoRef exists
                if (videoRef.current) {
                  // Set the stream to the video element
                  videoRef.current.srcObject = stream;
        
                  // Attempt to play the video
                  videoRef.current.play().catch(playError => {
                    console.error("Video play failed: ", playError);
                  });
                }
              } catch (error) {
                console.error("Error setting video stream: ", error);
              }
            
        })
        .catch(err => {
            console.error("Error accessing camera: ", err);
        });

    }

       
  };

  const takePicture = () => {
    const context = canvasRef.current.getContext('2d');
    canvasRef.current.width = 1080;
    canvasRef.current.height = 1080;
    context.drawImage(videoRef.current, 0, 0, 1080, 1080);
    videoRef.current.srcObject.getTracks().forEach(track => track.stop());

    const dataUrl = canvasRef.current.toDataURL('image/png');
    setPreview(dataUrl);

    fetch(dataUrl)
        .then(res => res.blob())
        .then(blob => {
            // Create a new File object for the captured image
            const pageIndex = recapturingPageIndex !== null ? recapturingPageIndex + 1 : capturedImages.length + 1;
            const file = new File([blob], `page${pageIndex}.png`, { type: 'image/png' });

            if (recapturingPageIndex !== null) {
                // If we're recapturing an image, replace the image at the specific index
                setCapturedImages(prevImages => {
                    const updatedImages = [...prevImages];
                    updatedImages[recapturingPageIndex] = file; // Replace the image at the recapturingPageIndex

                    onImageChange(updatedImages, keyName,"recapture");


                    return updatedImages;
                });



 

                // Reset recapturingPageIndex to null after updating the image
                setRecapturingPageIndex(null);
            } else {
                // If we're not recapturing, just add the new image
                setCapturedImages(prevImages => [...prevImages, file]); 
            }

            setImageName(file.name);

            // Trigger animation (e.g., blinking effect for a short period)
            setIsAnimating(true);
            setTimeout(() => {
                setIsAnimating(false);
            }, 500);

            // Play click sound
            playClickSound();

            // Notify parent component with the new image
            onImageChange(file, keyName);

            // Close the camera and reset other states
            openCamera();
            setIsPDF(false);
            setPdfFile(false);
        });
};

  const retakePhoto = () => {
      setPreview(null);
      setImageName('');
      openCamera();
  };

  const [recapturingPageIndex, setRecapturingPageIndex] = useState(null);

  useEffect(()=>{
    console.log(recapturingPageIndex);
  },[recapturingPageIndex])

 

  const [isFilenameChanging, setIsFilenameChanging] = useState(false);
  const removeImage = (index) => {
    // Trigger blinking effect when filename changes
    setIsFilenameChanging(true);


    // Remove the image at the specified index
    const updatedImages = capturedImages.filter((_, i) => i !== index);

    // Re-number the images and update the filenames
    const renumberedImages = updatedImages.map((img, newIndex) => {
        const newFileName = `page${newIndex + 1}.png`; // Re-number the filenames
        const updatedFile = new File([img], newFileName, { type: 'image/png' });
        return updatedFile;
    });
    setCapturedImages(renumberedImages);
    onImageChange(renumberedImages, keyName,"delete");

    setTimeout(() => {
        setIsFilenameChanging(false);
    }, 1000);
};

  const fileInputRef = useRef(null);
  const handleClick = () => {
     Swal.fire({
                title: 'Previously scanned/uploaded document(s) will be deleted \n IF YOU UPLOAD A PDF.',
                text: 'Do you want to continue?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'btn-danger',
                cancelButtonColor: 'btn-secondary',
                confirmButtonText: 'Yes, just upload the documents.',
                cancelButtonText: 'No, cancel',
                confirmButtonColor: '#03c3ec',
                cancelButtonColor: '#ff3e1d',
              }).then((result) => {
                if (result.isConfirmed) {
                    try {
                        fileInputRef.current.click();
                    } catch (error) {
                     
                    }
                } else if (result.isDenied) {
                    
                }
              });

  };

    const handleCameraChange = (event) => {
        setSelectedCamera(event.target.value);
    };

useEffect(() => {
    if (selectedCamera) {
        openCamera();
    }
}, [selectedCamera]);

    return (
        <div className="col">
            <div className="row g-4">
                <div className="col">
                    <div className="mb-2 gap-1">
                        <div className="me-1">
                            <h5 className="mb-1">Documents</h5>
                            <p className="mb-1"><span className="fw-medium">Upload requirements.</span></p>
                        </div>

                        <div className="card shadow-none border rounded" style={{maxHeight: 860, minHeight: 500}}>
                            <div className="card-body">
                                <input type='file' className="form-control d-none" ref={fileInputRef} onChange={handleFile} />
                                {pdfError && <span className='text-danger'>{pdfError}</span>}



                                {isCameraOpen && (
                                    <>
                                        <div className={`card-img card-img-right bg-label-info d-flex position-relative justify-content-center ${isAnimating ? 'camera-blinking' : ''}`}>
                                            <div className="card w-100">

                                                {recapturingPageIndex !== null ?
                                                    <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-danger p-1 rounded blinking">Recapturing Page {parseInt(recapturingPageIndex ?? 1) + 1}</span>
                                                    :
                                                    (preview ?
                                                        <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-dark p-1 rounded">Image Preview</span>
                                                        :
                                                        <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-danger p-1 rounded blinking">
                                                            <i class="bx bxs-camera fs-3"></i>
                                                        </span>
                                                    )
                                                }

                                                <video ref={videoRef} className='rounded-top w-100'></video>
                                                <canvas ref={canvasRef} style={{ display: 'none' }} width="275" height="275"></canvas>



                                                <div className="d-flex justify-content-center align-items-center position-absolute w-100 bottom-0 mb-2">
                                                    <div className="demo-inline-spacing">
                                                        <button type="button" className="btn rounded-pill btn-icon btn-info" onClick={takePicture}>
                                                            <span className="tf-icons bx bx-camera" title="Take a shot" />
                                                        </button>



                                                    </div>

                                                </div>

                                            </div>
                                        </div>



                                    </>
                                )}


                                {isCameraOpen && cameras.length > 0 && (
                                    <div className="col-12 text-center mb-2">
                                        <select className="form-control rounded-0 rounded-bottom" onChange={handleCameraChange} value={selectedCamera}>
                                            {cameras.map((camera) => {
                                                const cameraName = camera.label.replace(/\s?\(.*\)/, '');

                                                return (<option key={camera.deviceId} value={camera.deviceId}>
                                                    {cameraName || camera.label || `Camera ${camera.deviceId}`}
                                                </option>)
                                            }
                                            )}
                                        </select>
                                    </div>
                                )}

                                {preview && (
                                    <div className="card-img card-img-right bg-label-info d-flex position-relative justify-content-center">
                                        <div className="card w-100">
                                            <span className="card-title d-flex position-absolute mt-2 ms-2 text-white bg-dark p-1 rounded">Image Preview</span>
                                            <img className="card-img-top rounded-top w-100 bg-dark" src={preview} alt="Preview" style={{ minWidth: "33%", height: 450, objectFit: "contain" }} />
                                        </div>
                                    </div>
                                )}

                                <h4 className="my-2 pb-1">{title}</h4>
                                <p className="small mb-3">{subtitle}</p>


                                {!preview && !isCameraOpen && (
                                    <div className={`card-img rounded-3 mb-2 d-flex flex-column align-items-center justify-content-center border border-dashed border-2 w-100`} style={{ height: 275 }}>
                                        <h4 className='w-100 text-center'>Upload or Scan Documents</h4>
                                        <i className='bx fs-1 bxs-image'></i>
                                    </div>
                                )}


                                <span className="fw-bold text-primary d-block">
                                    <i>
                                        Note: If you're going to upload a PDF, all previously scanned images will be removed. You can only upload either a PDF or images, but not both.
                                    </i>
                                </span>


                               

                                {pdfFile && isPDF &&
                                    <span className='fw-bold fs-6 text-info mt-0'>
                                        To upload: PDF File
                                    </span>
                                }




                                <div className="btn-group w-100 gap-1" role="group" >
                                    {!isCameraOpen &&
                                        <button className="btn btn-label-dark" type="button" onClick={openCamera}>
                                            {btnCameraTitle}
                                        </button>
                                    }

                                    <button className="btn btn-label-dark" type="button" onClick={handleClick}>
                                        {'Upload Documents'}
                                    </button>


                                </div>



                            </div>
                        </div>

                    </div>

                </div>

                <div className="col">
                    <div className="mb-2 gap-1">
                        <div className="me-1">
                            <h5 className="mb-1">Captured / Uploaded Documents</h5>
                            <p className="mb-1"><span className="fw-medium">List of captured documents.</span></p>
                        </div>
                        <div className="row d-flex justify-content-center align-items-start border rounded" style={{ maxHeight: 860, overflowY: "scroll", minHeight: 500 }}>
 
    
   
                            {pdfFile && capturedImages.length === 0 &&
                                <Worker workerUrl="../js/pdf.worker.min.js">
                                    <Viewer fileUrl={pdfFile} plugins={[defaultLayoutPluginInstance]}></Viewer>
                                </Worker>
                            }

                            {capturedImages.length > 0 &&
                                <div className="alert alert-primary d-flex rounded-0 position-sticky top-0 " role="alert" style={{ zIndex: 1 }}>
                                    <span className='fw-bold fs-6 text-primary'>PAGES TO UPLOAD : {capturedImages.length}</span>
                                </div>


                            //    <div className='position-sticky top-0 mt-2'>
                            //      <span className='fw-bold fs-6 text-primary w-100 py-2 sticky'>
                            //         PAGES TO UPLOAD: {capturedImages.length}
                            //     </span>
                            //    </div>
                            }

                            {capturedImages.length > 0 && (

                                capturedImages.map((img, index) => (
                                    <div key={index} className="rounded shadow px-0 mx-3 mt-4 mb-2 h-100" style={{ width: "11.25rem", borderRadius: "0, 0, 10,10" }}>

                                        <div className="p-0 m-0 w-100 ">
                                            <img src={URL.createObjectURL(img)} alt={`Captured ${index}`} className='img-fluid p-0 m-0 rounded-top bg-dark' style={{ minHeight: 180, maxHeight: 180, objectFit: "contain" }} />
                                            <div className="fw-bolder ms-2">
                                                page<span className={`text-danger ${isFilenameChanging ? 'blinking-text' : ''}`}>({img.name.replace(/page|\.png/g, "")})</span>.png
                                            </div>
                                            <div className="dz-size pt-0" >
                                                <strong>{(img.size / (1024 * 1024)).toFixed(2)}</strong> MB
                                            </div>
                                        </div>





                                        <div className="btn-group w-100"  >
                                            <Tooltip title="Remove Document" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
                                                <button type="button" className="btn btn-primary rounded-0 rounded-bottom" 
                                                // style={{ borderRadius: "0 0 0 8px" }}
                                                onClick={() => removeImage(index)}>
                                                    <i className='bx bxs-trash' ></i>
                                                </button>
                                            </Tooltip>

                                            {/* <Tooltip title="Recapture Document" slotProps={{ tooltip: { sx: { fontSize: '1.15em' } } }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-info d-none " style={{ borderRadius: "0 0 8px 0" }}
                                                    onClick={() => {
                                                        setOpen(false); // Close the modal when capturing a new image
                                                        openCamera();
                                                        setImageName(""); // Reset the image name
                                                        setRecapturingPageIndex(index); // Set the page number to recapture
                                                    }}>
                                                    <i className='bx bxs-edit'></i>
                                                </button>
                                            </Tooltip> */}
                                        </div>



                                    </div>
                                ))
                            )}
                        </div>




                    </div>
                </div>
            </div>
        </div>
    );
};

export default PDFImageViewer2;

